<template>
  <div class="pointage-reporting-view">
    <Header title="Reporting de Pointage" />
    
    <div class="pointage-content">
      <h4>📊 Rapports et analyses des pointages</h4>
      
      <div class="content-placeholder">
        <div class="placeholder-icon">
          <span class="material-icons">summarize</span>
        </div>
        <h3>Reporting de pointage</h3>
        <p>Cette fonctionnalité est en cours de développement.</p>
        <p>Le module de reporting permettra de générer des rapports détaillés sur les pointages des agents.</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import Header from '@/components/Header.vue'

onMounted(() => {
  //console.log('PointageReportingView mounted')
})
</script>

<style scoped>
.pointage-reporting-view {
  min-height: 100vh;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f8f9fa;
}

.pointage-content {
  padding: 20px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.pointage-content h4 {
  margin-top: 0;
  margin-bottom: 20px;
  font-size: 1.2rem;
  font-weight: 500;
  color: #333;
}

.content-placeholder {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 40px;
  text-align: center;
}

.placeholder-icon {
  width: 80px;
  height: 80px;
  background-color: #e3f2fd;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.placeholder-icon .material-icons {
  font-size: 40px;
  color: #1976d2;
}

.content-placeholder h3 {
  margin: 0 0 15px;
  color: #333;
}

.content-placeholder p {
  margin: 5px 0;
  color: #666;
  max-width: 400px;
}
</style>
